import React, { useState, createContext, useContext } from "react";

const intialselectedFilter = "";
const intialFilterObjData = [];
const equipmentStatusTracker = "All";
const SelectedFilterContext = createContext(intialselectedFilter);
const SelectedFilterActionsContext = createContext();

const ItemSelectedFilterContext = createContext(intialFilterObjData);
const ItemSelectedFilterActionsContext = createContext();

const EquipmentStatusContext = createContext(equipmentStatusTracker);
const EquipmentStatusActionsContext = createContext();

export const useEquipmentStatusContext = () =>
  useContext(EquipmentStatusContext);
export const useEquipmentStatusActionsContext = () =>
  useContext(EquipmentStatusActionsContext);

export const useSelectedFilterContext = () => useContext(SelectedFilterContext);
export const useSelectedFilterActionsContext = () =>
  useContext(SelectedFilterActionsContext);

export const useItemSelectedFilterContext = () =>
  useContext(ItemSelectedFilterContext);
export const useItemSelectedFilterActionsContext = () =>
  useContext(ItemSelectedFilterActionsContext);

export const SelectedFilterChangeProvider = ({ children }) => {
  const [selectedFilter, setSelectedFilter] = useState("");
  const [itemSelectedFilter, setItemSelectedFilter] = useState([]);
  const [equipmentStatus, setEquipmentStatus] = useState("not");

  const updateSelectedFilter = (filterValue) => {
    setSelectedFilter((prev) => filterValue);
  };

  const updateListSelectedFilter = (item) => {
    setItemSelectedFilter((prev) => item);
  };

  const updateEquipmentStatus = (_value) => {
    setEquipmentStatus(_value);
  };

  return (
    <SelectedFilterActionsContext.Provider value={updateSelectedFilter}>
      <SelectedFilterContext.Provider value={selectedFilter}>
        <ItemSelectedFilterActionsContext.Provider
          value={updateListSelectedFilter}
        >
          <ItemSelectedFilterContext.Provider value={itemSelectedFilter}>
            <EquipmentStatusActionsContext.Provider
              value={updateEquipmentStatus}
            >
              <EquipmentStatusContext.Provider value={equipmentStatus}>
                {children}
              </EquipmentStatusContext.Provider>
            </EquipmentStatusActionsContext.Provider>
          </ItemSelectedFilterContext.Provider>
        </ItemSelectedFilterActionsContext.Provider>
      </SelectedFilterContext.Provider>
    </SelectedFilterActionsContext.Provider>
  );
};
